export function toolPermissionsTitle(data) {
  const app = data?.toolkit_name ?? 'Tool permissions'
  return data?.display_label ? `Tool permissions for ${app} – ${data.display_label}` : app
}
